import _lazy from './Lazy';

export { _lazy as Lazy };
